export default function QuoterCoverageLength() {
    return [
        { value: '10', label: '10-Year Term' },
        { value: '15', label: '15-Year Term' },
        { value: '20', label: '20-Year Term' },
        { value: '25', label: '25-Year Term' },
        { value: '30', label: '30-Year Term' },
        { value: '35', label: '35-Year Term' },
        { value: '40', label: '40-Year Term' },
    ];
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/CoverageLengths/QuoterCoverageLengths.js